import angular from 'angular';

import {ctxMessageComposer} from '../context/message-composer.js';

angular.module('messenger').directive('onswAttachments', [
  'Widget',
  'attachmentList',
  'sock',
  function (Widget, attachmentList, sock) {
    function link($scope, $element) {
      const widget = new Widget($scope, $element, 'ons-table');

      widget.busy(attachmentList.get()).then(function (attachments) {
        $scope.attachments = attachments;
      });

      $scope.select = function (attachment) {
        if (attachment.locked) {
          return false;
        }
        try {
          ctxMessageComposer.value($element[0]).attachment = attachment;
        } catch (reason) {
        }
        $scope.onselect();
        return true;
      };

      $scope.delete = function (item) {
        item.remove();
      };

      sock.$on($scope, 'attachments.update', function () {
        widget
          .clear()
          .busy(attachmentList.get())
          .then(function (res) {
            $scope.attachments = res;
          });
      });
    }

    return {
      link: link,
      scope: {
        onselect: '&',
      },
      templateUrl: '/template/messenger.attachments',
    };
  },
]);
